/**
 * @zoopla/assets should be for the rare occasions of widely-shared assets –
 * e.g. the Zoopla logo, the My Home "logo" – but not for images that are used
 * within individual libs.
 *
 * @see{docs/STATIC-ASSETS.md}
 */

// Logos
export { default as ZooplaLogo } from './logos/ZooplaLogo/ZooplaLogo';
export { default as ZooplaAnimatedLogo } from './logos/ZooplaAnimatedLogo/ZooplaAnimatedLogo';
export { default as PrideLogo } from './logos/PrideLogo/PrideLogo';
export { default as MojoLogo } from './logos/MojoLogo/MojoLogo';
export { default as MyHomeLockup } from './logos/MyHome/MyHomeLockup';
export { default as HelpToBuyLogo } from './logos/HelpToBuyLogo/HelpToBuyLogo';
export { default as HelpToBuyWithTextLogo } from './logos/HelpToBuyLogo/HelpToBuyWithTextLogo';
export { default as SharedOwnershipLogo } from './logos/SharedOwnershipLogo/SharedOwnershipLogo';

// Sprites
export { PICTOGRAMS_REMOTE_SPRITE_URL } from './pictograms/constants';

// To share between relevant libs (they're used in multiple places)
export { default as ZooplaPeak22767 } from './lib/ZOOPLA_PEAK2_2767.jpg';
export { default as ErrorNoResults } from './lib/error-no-results.svg';

// To unify later (shared pin)
export { default as MapBalloon } from './lib/map-dynamic-small-purple-pin-ballon-with-outline.svg';

// To unify later (placeholders)
export { default as ImagePlaceholder } from './lib/image-placeholder.svg';
export { default as PlaceholderImage } from './lib/place-holder-image.jpg';
export { default as Placeholder } from './lib/placeholder.png';

// To move later (public with changes, but tested more thoroughly)
export { default as ZVTLoader } from './lib/zvt-loader.txt';
